<div class="data-panel layout-hbox" style="align-items: flex-start; gap: 10px" [formGroup]="userRolePermissionsForm">
    <div>
        <h4>Role Type</h4>
        <div>
            <wj-multi-select-list-box [itemsSource]="appRoles"
                                      displayMemberPath="name"
                                      formControlName="roles"
                                      (click)="onCheckedRolesChanged()"
            ></wj-multi-select-list-box>
        </div>
    </div>

    <div>
        <h4>Country / LoB Permissions</h4>
        <div>
            <wj-flex-grid #rolesGrid [autoGenerateColumns]="false"
                          [headersVisibility]="Wijmo.HeadersVisibility.Column"
                          [allowResizing]="Wijmo.AllowResizing.Columns"
                          [allowSorting]="Wijmo.AllowSorting.None"
                          (initialized)="onRolesGridInit(rolesGrid)"
                          (dblclick)="onFlexGridDblClick($event, rolesGrid)"
            >
            </wj-flex-grid>
        </div>
    </div>
</div>
<div class="toolbar-horizontal">
    <fluent-button (click)="onUnsetRolePermissions()">
        <i class="fas fa-undo"></i> Reset
    </fluent-button>
    <fluent-button (click)="onApplyRolePermissions()" [disabled]="!isDirty()">
        <i class="fas fa-save"></i> Apply
    </fluent-button>
</div>
